/** @jsxImportSource react */
import IconInfoTileHeader from '@react/shared/components/IconInfoTile/IconInfoTileHeader';
import IconInfoTileIcon from '@react/shared/components/IconInfoTile/IconInfoTileIcon';
import { IconName } from '@sly/icons/icon.types';
export interface IconInfoTileProps {
  noPadding?: boolean;
  noBorder?: boolean;
  layout: 'iconTop' | 'default';
  iconBorder: boolean;
  icon: IconName;
  heading: string;
  content: string;
}

export default function IconInfoTile({
  noPadding,
  noBorder,
  layout,
  iconBorder,
  icon,
  heading,
  content,
}: IconInfoTileProps) {
  const padding = noPadding ? '' : 'p-6';
  const border = noBorder ? '' : 'border-[0.062rem] border-slate-200';
  const flexDirection = layout === 'iconTop' ? 'lg:flex-col' : 'lg:flex-row';
  return (
    <div
      className={`flex ${padding} ${border} flex-row rounded-sm ${flexDirection}`}
      data-tp-id='gen-div-59c615e3-7cdb-4158-bf61-391fc9429a80'
    >
      <IconInfoTileIcon iconBorder={iconBorder} layout={layout} icon={icon} />
      <IconInfoTileHeader layout={layout} heading={heading} content={content} />
    </div>
  );
}
